import React from 'react';
import { useLocation } from 'react-router-dom';
import ChannelInfo from '../components/ChannelInfo';
import PlayList from '../components/PlayList';

function VideoDetail(props) {
  const {
    state: { video },
  } = useLocation();
  // console.log(video);
  const { title, channelId, channelTitle, description } = video.snippet;
  return (
    <section className='flex flex-col lg:flex-row'>
      <article className='basis-4/6'>
        <iframe
          className='rounded-lg'
          id='player'
          type='text/html'
          width='100%'
          height='600px'
          src={`https://www.youtube.com/embed/${video.id}`}
          frameborder='0'
          title={title}
        />
        <div className='p-8'>
          <h2 className='text-xl font-bold'>{title}</h2>
          <ChannelInfo id={channelId} name={channelTitle} />
          <pre className='whitespace-pre-wrap'>{description}</pre>
        </div>
      </article>
      <section className='basis-2/6'>
        <PlayList id={channelId} />
      </section>
    </section>
  );
}

export default VideoDetail;
